$(document).ready(function() {
  
  /*============================================================================
      Accordion in Help Pages
    ==============================================================================*/
  
  $(function() {
    $('.accordion__title').click(function(j) {
      var dropDown = $(this).closest('.accordion__card').find('.accordion__panel');
      $(this).closest('.accordion').find('.accordion__panel').not(dropDown).slideUp();

      if ($(this).hasClass('accordion__active')) {
        $(this).removeClass('accordion__active');
      } 
      else {
        $(this).closest('.accordion').find('.accordion__title.accordion__active').removeClass('accordion__active');
        $(this).addClass('accordion__active');
      }

      dropDown.stop(false, true).slideToggle();
      j.preventDefault();
    });
  });

  $(function() {
    $('.inner_accordion__title').click(function(j) {
      var dropDown = $(this).closest('.inner_accordion__card').find('.inner_accordion__panel');
      $(this).closest('.accordion').find('.inner_accordion__panel').not(dropDown).slideUp();

      if ($(this).hasClass('inner_accordion__active')) {
        $(this).removeClass('inner_accordion__active');
      } 
      else {
        $(this).closest('.accordion').find('.inner_accordion__title.inner_accordion__active').removeClass('inner_accordion__active');
        $(this).addClass('inner_accordion__active');
      }

      dropDown.stop(false, true).slideToggle();
      j.preventDefault();
    });
  });

  $(function() {
    $('.inner_sub_accordion__title').click(function(j) {
      var dropDown = $(this).closest('.inner_sub_accordion__card').find('.inner_sub_accordion__panel');
      $(this).closest('.accordion').find('.inner_sub_accordion__panel').not(dropDown).slideUp();

      if ($(this).hasClass('inner_sub_accordion__active')) {
        $(this).removeClass('inner_sub_accordion__active');
      } 
      else {
        $(this).closest('.accordion').find('.inner_sub_accordion__title.inner_sub_accordion__active').removeClass('inner_sub_accordion__active');
        $(this).addClass('inner_sub_accordion__active');
      }

      dropDown.stop(false, true).slideToggle();
      j.preventDefault();
    });
  });

});

